const {publicPath} = require("../../web.config");
// import {message} from "ant-design-vue";
import client from "webpack-theme-color-replacer/client";
import {generate} from "@ant-design/colors/dist";

export default {
    getAntdSerials(color) {
        // 淡化（即less的tint）
        const lightens = new Array(9).fill().map((t, i) => {
            return client.varyColor.lighten(color, i / 10);
        })
        // colorPalette变换得到颜色值
        const colorPalettes = generate(color);
        const rgb = client.varyColor.toNum3(color.replace("#", "")).join(",");
        return lightens.concat(colorPalettes).concat(rgb);
    },
    changeColor(newColor) {
        var options = {
            newColors: this.getAntdSerials(newColor), // new colors array, one-to-one corresponde with `matchColors`
            cssUrl:`${publicPath}/css/theme-colors.css`
        }
        return client.changer.changeColor(options, Promise);
    },
    updateTheme(newPrimaryColor) {
        // const hideMessage = message.loading("正在切换主题！", 0)
        this.changeColor(newPrimaryColor).finally(() => {
            setTimeout(() => {
                // hideMessage()
            }, 10)
        })
    }
}
